import { z } from 'zod';

/** Most saved instructions an account can have. */
export const MAX_SAVED_INSTRUCTIONS = 30;
/** Most saved instructions one rewrite can follow. */
export const MAX_INSTRUCTIONS_PER_REWRITE = 10;
export const MAX_INSTRUCTION_NAME_LENGTH = 40;
export const MAX_SAVED_INSTRUCTION_LENGTH = 500;

/**
 * An instruction a writer keeps for rewrites, such as how to lay them out: unlike a tone, it's
 * about the result rather than how it sounds, and several can apply to one rewrite.
 */
export const SavedInstructionInputSchema = z
  .object({
    name: z
      .string()
      .trim()
      .min(1)
      .max(MAX_INSTRUCTION_NAME_LENGTH)
      .describe('What the instruction is called, as the instruction menu lists it.'),
    text: z
      .string()
      .trim()
      .min(1)
      .max(MAX_SAVED_INSTRUCTION_LENGTH)
      .describe(
        'What rewrites should do, in the writer’s words, such as “use bullet points for steps”.',
      ),
  })
  .meta({ id: 'SavedInstructionInput' });

export type SavedInstructionInput = z.infer<typeof SavedInstructionInputSchema>;

export const SavedInstructionSchema = SavedInstructionInputSchema.extend({ id: z.string() }).meta({
  id: 'SavedInstruction',
});

export type SavedInstruction = z.infer<typeof SavedInstructionSchema>;

export const SavedInstructionResponseSchema = z
  .object({ instruction: SavedInstructionSchema })
  .meta({ id: 'SavedInstructionResponse' });

export const SavedInstructionsResponseSchema = z
  .object({ instructions: z.array(SavedInstructionSchema).describe('Oldest first.') })
  .meta({ id: 'SavedInstructions' });
